<template>
    <div>
        <el-container>
            <el-main>
                <div>

                    <el-card style="width: 50%;margin-left: 20%">
                        <el-card>
                            <div style="color: #555555;">
                                <p style="color:red">*温馨提示</p>
                                <p>1. 请输入不大于佣金的提现金额</p>
                                <p>2. 暂时只支持支付宝提现,请填写正确的支付宝号码。</p>
                                <p>3. 提现为工作日的24小时到账，非工作日时间暂不处理提现申请。</p>
                                <p>4. 为提高财务处理提现申请效率，提现申请定为每月5号、20号两日。</p>
                                <p style="color: red">5. 以下的可提佣金为当前可以提现的佣金（包含已提现未审核的情况）。</p>
                            </div>
                        </el-card>

                        <el-form statu-icon :model="dataPro" ref="dataPro" label-width="100px" style="margin-top: 5%">
                            <el-form-item  label="可提佣金">
                                <el-input v-model="dataPro.profitPrice.toFixed(2)" readonly></el-input>
                            </el-form-item>
                            <el-form-item prop="account" :rules="[{required:true,message:'请填写支付宝账号',trigger:'blur'}]" label="支付宝账号">
                                <el-input  v-model="dataPro.account" placeholder="请输入支付宝号"></el-input>
                            </el-form-item>
                            <el-form-item prop="accountName" :rules="[{required:true,message:'请填写支付宝用户名',trigger:'blur'}]" label="支付宝用户">
                                <el-input  v-model="dataPro.accountName" placeholder="请输入支付宝用户名"></el-input>
                            </el-form-item>
                            <el-form-item prop="money" :rules="[{required:true,message:'提现金额不能为空',trigger:'blur'},
                            {type:'number',message: '必须为数字',trigger: 'blur'}]" label="提现金额">
                                <el-input   v-model.number="dataPro.money" placeholder="请输入提现金额"></el-input>
                            </el-form-item>

                        </el-form>



                        <div style="margin-top:10px;margin-left: 10%">
                            <el-button round type="info"  style="margin-left: 25%;" plain @click="dialogFormVisible('dataPro')">重置</el-button>
                            <el-button :disabled="roleId==='777'" round style="margin-bottom: 5%;" type="primary" plain @click="applySub('dataPro')">{{title}}</el-button>
                        </div>




                    </el-card>
                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    export default {
        name: 'profitCheck',
        components: {  },
        mounted: function () {
            let _this = this
            _this.loadType()
            _this.title= _this.roleId==='777'?'管理员不可申请':'申请提交'
        },
        data() {
            return {
                roleId: this.$loginUser.roleId,
                title: '',
                dataPro: {
                    profitPrice: 0.00,
                    account: '',
                    accountName: '',
                    money: 0.00
                },
                agentJs: require('../../../api/profit')
            }
        },
        methods: {
            loadType() {
                let _this = this
                _this.agentJs.getCommission().then(response => {
                    _this.dataPro = response.data.data
                })
            },
            dialogFormVisible(form) {
                let _this = this
                _this.$refs[form].resetFields()
            },

            //分润提现申请
            applySub(form) {
                let _this = this
                _this.$refs[form].validate(v=>{
                    if(v){
                        let now= new Date()
                        let day = now.getDate()
                        if (day !== 5 && day !== 20) {
                            _this.$alert('今日不可发起提现申请，如需提现请5号、20号申请！')
                            return false
                        }
                        _this.agentJs.applySub(_this.dataPro)
                            .then(res => {
                                if (res.data.code === '0') {
                                    _this.$alert(res.data.data)
                                    _this.dialogFormVisible()
                                } else {
                                    _this.$alert(res.data.msg)
                                    _this.dialogFormVisible()
                                }
                            })
                            .catch(err => {
                                _this.dialogFormVisible()
                            })
                    }

                })

            }
        }
    }
</script>

<style scoped>
    .foot {
        border: 2px solid #000;
    }
    /deep/.el-main {
        text-align: left;
        padding: 20px !important;
        overflow: hidden !important;
    }
</style>
